import { Paper, Tab, Tabs, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import * as EVENTS from '../App/Constants/Events';
import * as TELEMETRY from '../App/Constants/Telemetry';
import * as TRANSITION from '../App/Constants/Transition'
import DocumentStore from '../App/Stores/DocumentStore';
import DocumentListItem from '../App/Models/DocumentListItem';
import PictureAsPdf  from '@material-ui/icons/PictureAsPdf';

const styles = (theme: any) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  }
});

interface Props {
  documentStore: DocumentStore;
  document: DocumentListItem
}

class DocumentDownloader extends React.Component<Props> {

  private timeout: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0,
      isDisplayLoadingAnimation: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(id: string): void {
    const { documentStore } = this.props;
    if (!documentStore || !id) return;
    documentStore.getNZFAPDocument(id).then(async result => {
      console.log(result);
      const data = result && result.data;
      if (!data) return;
      const url = URL.createObjectURL(data);
      window.open(url);
    });
  }

  cleanupName(name: string){
    let result = name.replaceAll('_', ' ');
    result = result.replace('.pdf', '');
    if(result.length > 70){
      result = result.substring(0, 67).concat('...');
    }

    return result
  }

  render() {
    const {  documentStore, document } = this.props;
    return (
      <div className="c-documents__list-document-download">
        <div className='c-documents__list-document-download-flex-container'>
          <div className='c-documents__list-document-download-icon-container'><PictureAsPdf className='c-documents__list-document-download-icon'></PictureAsPdf></div>
          <div className='c-documents__list-document-download-name-container'>{this.cleanupName(document.name)}</div>
        </div>
        <div className='c-documents__list-document-download-button-container' onClick={() => document.id && this.handleClick(document.id)}><div className='c-documents__list-document-download-button'>Open</div></div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(DocumentDownloader);